import {
  Box,
  Grid,
  LinearProgress,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { ReactComponent as Coverage } from 'assets/images/ic_policy_coverage.svg';
import { ReactComponent as Attestation } from 'assets/images/ic_attestation.svg';
import { ReactComponent as OnTime } from 'assets/images/ic_policy_on_time.svg';

const PolicyDataset = (props: PolicyDatasetProps): React.ReactElement => {
  const {
    totalPolicies,
    totalAcknowledgements,
    completedAcknowledgements,
    acknowledgementPercentage,
    assigedAcknowledgements,
  } = props;
  return (
    <Box className="policy-dataset-wrapper">
      <Grid container className="policy-array-set">
        <Grid item xs={12} sm={6}>
          <Box className="policy-outstanding">
            <Stack direction="row">
              <SvgIcon
                component={Attestation}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#76A81F"
              />
              <Typography variant="body1">Total Policies</Typography>
            </Stack>
            <Stack direction="column" spacing={3}>
              <Typography variant="h6">{totalPolicies}</Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className="policy-coverage-dataset">
            <Stack direction="row">
              <SvgIcon
                component={Coverage}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#76A81F"
              />
              <Typography variant="body1">Policy coverage</Typography>
            </Stack>
            <Stack direction="column" spacing={3}>
              <Typography variant="h6">{acknowledgementPercentage}%</Typography>
              <LinearProgress
                variant="determinate"
                value={acknowledgementPercentage}
              />
              <Typography component="span">
                {completedAcknowledgements} of {totalAcknowledgements}{' '}
                assignments completed
              </Typography>
            </Stack>
          </Box>
        </Grid>
        {false && (
          <Grid item xs={12} md={4}>
            <Box className="policy-on-time">
              <Stack direction="row">
                <SvgIcon
                  component={OnTime}
                  inheritViewBox
                  className="view-icon"
                  fontSize="inherit"
                  htmlColor="#3D3C42"
                />
                <Typography variant="body1">
                  Avg. acknowledgement time
                </Typography>
              </Stack>
              <Stack direction="column" spacing={3}>
                <Typography variant="h6">{assigedAcknowledgements}</Typography>

                <Typography component="span">Time to acknowledge</Typography>
              </Stack>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PolicyDataset;
